class CategorySaveController {

    constructor($rootScope, $state, access) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.access = access;
    }

    $onInit() {
        this.activeTab = 'profile';
    }
}

CategorySaveController.$inject = [ '$rootScope', '$state', 'access' ];

export default CategorySaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/category.save.controller.js